/* eslint-disable sonarjs/function-return-type */
// mantine
import { Loader } from '@mantine/core';
// components
import type { TAgentWithFlows } from '@newo/api/gateway';
import AgentRow from '@/pages/Agents/components/AgentRow';
import FlowsTable from '@/pages/Agents/components/FlowsTable';
import NoRecords from '@/components/NoRecords';
// utils
import { useAgentsListQuery } from '@/services/bff/bff.queries.ts';

interface AgentsGridProps {
    projectId?: string;
    onAgentEdit: (agent?: TAgentWithFlows) => void;
}

const AgentsGrid = ({ projectId, onAgentEdit }: AgentsGridProps) => {
    const {
        data: agents = [],
        isLoading,
        isSuccess
    } = useAgentsListQuery({
        project_id: projectId ?? undefined
    });

    if (isLoading) {
        return (
            <div className="flex justify-center py-60">
                <Loader />
            </div>
        );
    }

    if (agents.length === 0 && isSuccess) {
        return <NoRecords>No Agents Found</NoRecords>;
    }

    return agents.map((agent) => {
        return (
            <div className="mb-8" key={agent.id}>
                <AgentRow agent={agent} onAgentEdit={onAgentEdit} />
                {agent.flows.length > 0 && (
                    <FlowsTable className="mt-2" flows={agent.flows} />
                )}
            </div>
        );
    });
};

export default AgentsGrid;
